__turbopack_context__.v({
  "backgroundImage": "video-background-module__hS0Q8W__backgroundImage",
  "backgroundVideo": "video-background-module__hS0Q8W__backgroundVideo",
  "iframe": "video-background-module__hS0Q8W__iframe",
  "overlay": "video-background-module__hS0Q8W__overlay",
  "poster": "video-background-module__hS0Q8W__poster",
  "posterEnter": "video-background-module__hS0Q8W__posterEnter",
  "posterHide": "video-background-module__hS0Q8W__posterHide",
  "posterShow": "video-background-module__hS0Q8W__posterShow",
  "video": "video-background-module__hS0Q8W__video",
  "videoEmbedObjectFitCover": "video-background-module__hS0Q8W__videoEmbedObjectFitCover",
});
